import { BusinessProvider } from "./business_context";
import Business from "./business";

export default function BusinessWithContext() {
  return (
    <BusinessProvider>
      <Business />
    </BusinessProvider>
  );
}
